import axios from "axios";

const version = "v1/";
const URL = "https://api.human-design.space/";

export const HTTP = axios.create({
  baseURL: URL + version
});
